export const cancelReasons = [
  'pre_knowledge',
  'broker_not_authorized',
  'deviation',
  'asking_price',
  'yield',
  'lost',
  'findings',
  'no_permission',
  'no_investor',
  'no_debt',
  'failed',
  'withdrawal',
  'other',
];
